import has from "lodash/has";
import hasIn from "lodash/hasIn";
import isEmpty from "lodash/isEmpty";
import debounce from "lodash/debounce";

import Vue from "vue";
import "vue-datetime/dist/vue-datetime.css";

import DataTable from "./components/DataTable";
import DataTableInventoryListEquipment from "./components/DataTableInventoryListEquipment";

import FlashMessage from "./components/Alert";
import ConfirmModal from "./components/ConfirmModal";
import RemovedModal from "./components/RemovedModal";
import TextEditor from "./components/TextEditor";
import EventButton from "./components/EventButton";
import Dropdown from "./components/Dropdown";
import PdfFrame from "./components/PdfFrame";

import Cleave from "cleave.js";

import UsersForm from "./components/forms/Users";
import PostsForm from "./components/forms/Posts";
import StockMove from "./components/forms/StockMove";
import WarehouseReceipt from "./components/forms/WarehouseReceipt";
import WorkOrder from "./components/forms/WorkOrder";
import OnSiteWorkOrder from "./components/forms/OnSiteWorkOrder";
import RepairWorkOrder from "./components/forms/RepairWorkOrder";
import ModalExportFilter from "./components/forms/ModalExportFilter";
import ModalExportPondered from "./components/forms/ModalExportPondered";
import ModalExportOnSiteWorkOrder from "./components/forms/ModalExportOnSiteWorkOrder";
import ModalExportRepairLabWorkOrder from "./components/forms/ModalExportRepairLabWorkOrder";
import ModalExportRolloutLabWorkOrder from "./components/forms/ModalExportRolloutLabWorkOrder";
import ModalExportServices from "./components/forms/ModalExportServices";
import ModalExportEquipment from "./components/forms/ModalExportEquipment";
import ModalExportStockMoves from "./components/forms/ModalExportStockMoves";
import HandleFile from "./components/forms/HandleFile";
import VueDatePicker from "./components/DatePicker";
import ProductComp from "./components/forms/ProductComp";
import WarehouseComp from "./components/forms/WarehouseComp";
import PickLocations from "./components/forms/PickLocations";
import StockMoveFilter from "./components/filters/StockMoveFilter";
import WorkOrderFilter from "./components/filters/WorkOrderFilter.vue";

Vue.config.productionTip = false;

Vue.prototype._ = {
  has,
  hasIn,
  isEmpty,
  debounce,
};

Vue.mixin({
  methods: {
    route: route,
  },
});

window.Bus = new Vue();

const App = new Vue({
  el: "#app",

  components: {
    DataTable,
    ConfirmModal,
    FlashMessage,
    UsersForm,
    PostsForm,
    TextEditor,
    StockMove,
    WarehouseReceipt,
    WorkOrder,
    OnSiteWorkOrder,
    RepairWorkOrder,
    ModalExportFilter,
    ModalExportPondered,
    HandleFile,
    VueDatePicker,
    DataTableInventoryListEquipment,
    ProductComp,
    RemovedModal,
    WarehouseComp,
    ModalExportOnSiteWorkOrder,
    ModalExportRepairLabWorkOrder,
    ModalExportServices,
    ModalExportEquipment,
    ModalExportStockMoves,
    PickLocations,
    ModalExportRolloutLabWorkOrder,
    EventButton,
    Dropdown,
    PdfFrame,
    StockMoveFilter,
    WorkOrderFilter,
  },

  data: {
    auth: window.auth,
  },

  methods: {
    logout() {
      document.getElementById("logout-form").submit();
    },
  },
});

window.App = App;
global.Vue = App;

if (document.querySelector(".alert")) {
  setTimeout(() => {
    document.querySelector(".alert").remove();
  }, 5000);
}

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".input-date") !== null) {
    new Cleave(".input-date", {
      date: true,
      datePattern: ["Y", "m", "d"],
      delimiter: "-",
    });
  }

  if (document.querySelector(".input-time") !== null) {
    new Cleave(".input-time", {
      time: true,
      timePattern: ["h", "m"],
    });
  }
});
